"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = void 0;
const core_1 = require("@emotion/core");
const styled_1 = __importDefault(require("@emotion/styled"));
const styled_system_1 = require("styled-system");
exports.StyledBox = styled_1.default.div `
  box-sizing: border-box;
  display: "block";
  min-width: 0px;
  ${props => core_1.css `
    border-color: ${props.theme.colors.border};
    border-radius: ${props.theme.radii[1]}px;
  `};
  ${styled_system_1.border};
  ${styled_system_1.color};
  ${styled_system_1.flexbox};
  ${styled_system_1.layout};
  ${styled_system_1.position};
  ${styled_system_1.space};
  ${styled_system_1.typography};
`;
